import React from "react";
import { ChatProvider } from "@/contexts/ChatContext";
import { useChatContext } from "@/hooks/useChatContext";
import { ChatContainer } from "@/components/agent/chat/ChatContainer";
import { useAuth } from "@/contexts/AuthContext";
import { Database } from "@/types/database.types";

type Agent = Database["public"]["Tables"]["agents"]["Row"];

type AgentInternalChatTabProps = {
  agent: Agent;
  organization?: any;
  conversationId?: string | null;
};

// Inner component using the context
const AgentInternalChatContent = () => {
  const { agent, organization } = useChatContext();

  return (
    <div className="flex flex-col h-full w-full overflow-hidden bg-white">
      <ChatContainer isMobile={false} constrainWidth={true} />
    </div>
  );
};

const AgentInternalChatTab = ({
  agent,
  organization,
  conversationId,
}: AgentInternalChatTabProps) => {
  const { user } = useAuth();

  // For internal users, we pass the authenticated user info
  const userInfo = user
    ? {
        name: user.user_metadata?.full_name || user.email || "User",
        email: user.email || "",
      }
    : null;

  return (
    <ChatProvider
      agent={agent}
      organization={organization}
      isPublic={false}
      brandColor={organization?.brand_color || "#8aa3d9"}
      textColor="#FFFFFF"
      userInfo={userInfo}
      selectedConversationId={conversationId}
    >
      <div className="h-full w-full">
        <AgentInternalChatContent />
      </div>
    </ChatProvider>
  );
};

export default AgentInternalChatTab;
